import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvequote',
  templateUrl: './approvequote.component.html',
  styleUrls: ['./approvequote.component.scss']
})
export class ApprovequoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
